import { render, staticRenderFns } from "./mtCake.vue?vue&type=template&id=18777024&scoped=true&"
import script from "./mtCake.vue?vue&type=script&lang=js&"
export * from "./mtCake.vue?vue&type=script&lang=js&"
import style0 from "./mtCake.vue?vue&type=style&index=0&id=18777024&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18777024",
  null
  
)

export default component.exports